import { TabContext, TabList } from '@mui/lab';
import {
	Typography,
	Box,
	Grid,
	Icon,
	SelectChangeEvent,
	Stack,
} from '@mui/material';

import { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useLocation, Link, useNavigate } from 'react-router-dom';

import { ReactComponent as EditIcon } from 'common/assets/images/edit-Icon.svg';
import Breadcrumbs from 'common/components/Breadcrumbs/Breadcrumbs';
import ButtonComp from 'common/components/Button/ButtonComp';
import { Loader } from 'common/components/Loader/Loader';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import { APP_GENERAL_ERROR_MSG, appPages } from 'common/constants/TextContent';
import { TOOLTIP_TEXT } from 'common/constants/Tooltip';
import {
	setDeleteAIGeneratedCardPayload,
	setToastMessage,
} from 'common/store/reducer/commonReducer';
import {
	convertStringToArray,
	dateInCorrectFormatWithFullYear,
	hasInventoryManagerRole,
	toSentenceCase,
} from 'common/utils/utilFunctions';

import { IListOfMetaData } from 'features/RiskProfile/api/type-def';

import {
	getControlData,
	getRiskData,
	getProcessData,
	getListOfMetaData,
	submitPRCEditChanges,
	regenerateCards,
} from '../api';
import { controlHeaderData } from '../api/mockAPIResponse';
import {
	ITabValueData,
	IControlHeaderData,
	IProducts,
	IControlServiceData,
	IEntityStatementLoaders,
} from '../api/type-def';
import CoveredComp from '../Overview/CoveredComp';
import PreviewMappingLayout from '../RelationMapping/MappingDetail/PreviewMappingLayout';
import RelationMappingLayout from '../RelationMapping/RelationMappingLayout';
import StyledTab from '../StyledTab/StyledTab';
import {
	deletePendingAICards,
	disableBtnBasedOnRoleAndNewValue,
	disableSubmitChangesBtn,
	fetchControlHeaderData,
	fetchKeyBasedOnRole,
	fetchKeywordBasedOnLabel,
	fetchLabelBasedOnMetaData,
	fetchPayloadForRegenerateChanges,
	fetchToastMsg,
	fetchToastMsgData,
	fetchValueBasedOnIncomingType,
	filterMetaData,
	isIndustryTypeOrBusinessUnit,
	navigateToPage,
	renderCoveredPdts,
	renderOnlyForPRC,
	selectMetaDataFromDropdown,
	updateControlHeader,
	updatePayloadToCheckWithAuditKey,
} from '../TaxonomyUtils';

import SideDrawer from '../../../../common/components/SideDrawer/SideDrawer';
import {
	ENTITY_TYPE,
	INDUSTRY_LABEL,
	BUSINESS_UNIT_LABEL,
	CONTROL_TAB_LABEL,
	DATABASE_CATEGORY,
	PRC_BUTTON_TEXT,
	META_DATA_KEYWORD,
	RELATION_MAPPING_TAB_VALUES,
	PRC_TOAST_MSG,
	RISK_STATEMENT_KEY,
	ICONTROL_TAB_LOADERS,
	SUBMIT_CHANGES_MODAL_TYPE,
} from '../../../../common/constants/TaxonomyConstants';
import { RootState } from '../../../../common/store/AppStore';
import {
	setCitationDataHandler,
	setIsRegenerateMappingBtnClicked,
	setRiskRefTaxonomySourceFiltersKey,
} from '../../../../common/store/reducer/taxonomyReducer';
import styles from '../../../common/Common.module.scss';

import {
	getEntityDetailTemplate,
	getDetailsMappingObj,
	getLevelInfo,
} from './EntityLandingUtils';
import EntityStatementSection from './EntityStatementSection';
import HierarchyCard from './HierarchyCard';
import MetaDataEditModal from './MetaDataEditModal';
import SubmitChangesModal from './SubmitChangesModal';

import entityStyles from './EntityLanding.module.scss';

const EntityLandingPageLayout = () => {
	const { COVERED_PRODUCTS } = TOOLTIP_TEXT;
	const { PROCESS, CONTROL, RISK } = ENTITY_TYPE;
	const { OK, FORBIDDEN } = HTTP_STATUS_CODES;
	const { CONTROL_OBJECTIVE, CONTROL_STATEMENT, CONTROL_TEST_SCRIPTS } =
		CONTROL_TAB_LABEL;
	const { PWC_CURATED_LIBRARY } = DATABASE_CATEGORY;
	const { SUBMIT_CHANGES, DISCARD_CHANGES } = PRC_BUTTON_TEXT;
	const {
		INDUSTRY_KEYWORD,
		BUSINESS_UNIT_KEYWORD,
		CONTROL_OBJECTIVE_KEYWORD,
		RISK_STATEMENT_KEYWORD,
		CONTROL_STATEMENT_KEYWORD,
		CONTROL_TEST_SCRIPTS_KEYWORD,
	} = META_DATA_KEYWORD;
	const { ALL, AI_GENERATED } = RELATION_MAPPING_TAB_VALUES;
	const { SUBMIT } = SUBMIT_CHANGES_MODAL_TYPE;
	const {
		PRC_CHANGES_SUCCESS,
		PRC_CHANGES_FAILURE,
		PRC_REGENERATE_SUCCESS,
		PRC_REGENERATE_FAILURE,
		PRC_REGENERATE_DELETE_SUCCESS,
		PRC_REGENERATE_DELETE_FAILURE,
	} = PRC_TOAST_MSG;
	const {
		CONTROL_OBJECTIVE_LOADER,
		CONTROL_STATEMENT_LOADER,
		CONTROL_TEST_SCRIPTS_LOADER,
	} = ICONTROL_TAB_LOADERS;
	const { PRC_INVENTORY_PAGE, HOME_PAGE } = appPages;

	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const {
		tabSelectedTextColor,
		tabBackground,
		focustabColor,
		textColor,
		tabBorderRadius,
		iconFillColor,
	} = entityStyles;

	/* State Variables */
	const [, setEntityDetails] = useState<any>(null);
	const [products, setProducts] = useState<string[]>([]);
	const [coveredProductNames, setCoveredProductNames] = useState([]);
	const [detailsId, setdetailsId] = useState<string>('');
	const [displayIdUpdated, setdisplayId] = useState<string>('');
	const [levelList, setLevelList] = useState<string[]>([]);
	const [controlObjective, setObjective] = useState<string>('');
	const [controlStatement, setControlStatement] = useState<string>('');
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [industry, setIndustryType] = useState<string>('');
	const [businessUnit, setBusinessUnit] = useState<string>('');
	const [controlHeader, setControlHeader] =
		useState<IControlHeaderData[]>(controlHeaderData);
	const [tabValue, setTabValue] = useState<string>(CONTROL_OBJECTIVE);
	const [controlTestScripts, setControlTestScripts] = useState<string>('');
	const [controlTabs, setControlTabs] = useState<ITabValueData[]>([]);
	const [showStatement, setShowStatement] = useState<boolean>(false);
	const [selectedEntityData, setSelectedEntityData] = useState<any>();
	const [isMultiEditMetaDataModalOpen, setIsMultiEditMetaDataModalOpen] =
		useState<boolean>(false);
	const [mutilSelectedMetaDataOption, setMultiSelectedMetaDataOption] =
		useState<IListOfMetaData[]>([]);
	const [metaDataLabel, setMetaDataLabel] = useState<string>('');
	const [metaDataKey, setMetaDatakey] = useState<string>('');
	const [listOfMetaData, setListOfMetaData] = useState<IListOfMetaData[]>([]);
	const [updatedPayloadData, setUpdatedPayloadData] = useState<object>({});
	const [isEntityDetailsLoading, setIsEntityDetailsLoading] =
		useState<boolean>(true);
	const [isMetaDataListLoading, setIsMetaDataListLoading] =
		useState<boolean>(true);
	const [relationMappingTabValue, setRelationMappingTabValue] =
		useState<string>(ALL);
	const [initialDetails, setInitialDetails] = useState<any>();
	const [isSubmitDetailsLoading, setIsSubmitDetailsLoading] =
		useState<boolean>(false);
	const [disableUpdateBtn, setDisableUpdateBtn] = useState<boolean>(true);
	const [isRegenerating, setIsRegenerating] = useState<boolean>(false);
	const [isDiscardBtnClicked, setIsDiscardBtnClicked] =
		useState<boolean>(false);
	const [isSubmitModalOpen, setIsSubmitModalOpen] = useState<boolean>(false);
	const [disableBtnStatus, setDisableBtnStatus] =
		useState<IEntityStatementLoaders>({
			objective: false,
			statement: false,
			testscripts: false,
		});

	const [isEditAccessEnabled, setEditAccessEnabled] = useState<boolean>(false);
	const [auditKey, setAuditKey] = useState<string>('');
	const [auditID, setAuditID] = useState<string>('');
	const [selectedEntityType, setSelectedEntityType] = useState<string>('');
	const [selectedEntityName, setSelectedEntityName] = useState<string>('');
	const [routePath, setRoutePath] = useState<string>(PRC_INVENTORY_PAGE);
	const [entityId, setEntityId] = useState<string>('');
	const [isChangesDiscarded, setIsChangesDiscarded] = useState<boolean>(false);
	/* Store Variables */
	const entityData = useSelector(
		(state: RootState) => state.taxonomy.citationData,
	);
	const sideDrawerState = useSelector(
		(state: RootState) => state.common.mappingDrawer,
	);
	const riskRefTaxonomySourceFiltersKey = useSelector(
		(state: RootState) => state.taxonomy.riskRefTaxonomySourceFiltersKey,
	);
	const { isToastOpen, message, severity } = useSelector(
		(state: RootState) => state.common.toastMessage,
	);
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const isPRCEditDataDeleting = useSelector(
		(state: RootState) => state.taxonomy.isPRCEditDataDeleting,
	);
	const isRegenerateMappingBtnClicked = useSelector(
		(state: RootState) => state.taxonomy.isRegenerateMappingBtnClicked,
	);

	const isSubmitChangesButtonDisabled = useSelector(
		(state: RootState) => state.taxonomy.isSubmitChangesButtonDisabled,
	);

	/* Local Variables */
	const style = {
		'.MuiButtonBase-root': {
			border: 'none',
		},
		'.MuiButtonBase-root.MuiTab-root.Mui-selected': {
			color: tabSelectedTextColor,
			backgroundColor: tabBackground,
		},
		'.Mui-selected': {
			background: `${focustabColor} !important`,
			color: textColor,
			borderRadius: tabBorderRadius,
		},
		'.MuiTabs-indicator': {
			display: 'none',
		},
	};

	const hasInvManagerAccess = hasInventoryManagerRole(loggedInUser);
	const getEditAccessEnabledFlag = () => {
		let hasEditableAccess = false;
		if (hasInvManagerAccess) {
			hasEditableAccess = routePath !== PRC_INVENTORY_PAGE;
		}
		return hasEditableAccess;
	};

	/**
	 * @description method to trigger when tab value changes
	 * @param event, newValue
	 */
	const tabValueChangeHandler = (
		event: React.SyntheticEvent,
		newValue: string,
	) => {
		event.stopPropagation();
		setTabValue(newValue);
		// get the key here
	};

	const fetchFormattedDetailsForEntity = (responseBody: any) => {
		const { products, id, displayId } = responseBody;
		setdetailsId(id);
		setdisplayId(displayId);
		dispatch(setRiskRefTaxonomySourceFiltersKey(responseBody?.source));
		setIndustryType(
			fetchKeyBasedOnRole(hasInvManagerAccess, INDUSTRY_KEYWORD, responseBody),
		);
		setBusinessUnit(
			fetchKeyBasedOnRole(hasInvManagerAccess, INDUSTRY_KEYWORD, responseBody),
		);
		setControlHeader(
			fetchControlHeaderData(
				responseBody,
				riskRefTaxonomySourceFiltersKey,
				hasInvManagerAccess,
			),
		);
		setLevelList(getLevelInfo(responseBody));
		if (products && products.length > 0) {
			setProducts(products);
			const newCoveredPdts: any = [];
			products?.map((product: IProducts) =>
				newCoveredPdts.push({
					productName: product.productName,
					productId: product.productId,
					productAuthor: product.mappedUserId,
				}),
			);
			setCoveredProductNames(newCoveredPdts);
		} else {
			setProducts([]);
			setCoveredProductNames([]);
		}
		const entityTemplate = getEntityDetailTemplate(selectedEntityType);
		const detailsMappingObj = getDetailsMappingObj(selectedEntityType);
		entityTemplate.forEach((val: any) => {
			if (Object.keys(responseBody).includes(detailsMappingObj[val.label]))
				if (val.label === 'Date Modified' || val.label === 'Date Created') {
					val.value = dateInCorrectFormatWithFullYear(
						responseBody[detailsMappingObj[val.label]],
					);
				} else {
					val.value = responseBody[detailsMappingObj[val.label]];
				}
			return val;
		});
		return entityTemplate;
	};

	const resetControlDisplayTabs = (data: IControlServiceData) => {
		const controlTabValue = (() => {
			if ((data?.controlObjective ?? '').length > 0) return CONTROL_OBJECTIVE;
			if ((data?.controlStatement ?? '').length > 0) return CONTROL_STATEMENT;
			return '';
		})();
		setTabValue(controlTabValue);
		setShowStatement(controlTabValue !== '');
	};
	const resetStatementSectionActions = (
		data: IControlServiceData,
		isEditAcessEnabledByDefault: boolean,
	) => {
		const keywordsToCheck = [
			CONTROL_OBJECTIVE_KEYWORD,
			CONTROL_STATEMENT_KEYWORD,
			CONTROL_TEST_SCRIPTS_KEYWORD,
		];
		keywordsToCheck.forEach((keyword) => {
			if (
				disableBtnBasedOnRoleAndNewValue(
					hasInvManagerAccess,
					keyword,
					data,
					isEditAcessEnabledByDefault,
				)
			) {
				const getStatementKey =
					keyword === CONTROL_STATEMENT_KEYWORD
						? CONTROL_STATEMENT_LOADER
						: CONTROL_TEST_SCRIPTS_LOADER;
				const key =
					keyword === CONTROL_OBJECTIVE_KEYWORD
						? CONTROL_OBJECTIVE_LOADER
						: getStatementKey;

				setDisableBtnStatus((prevStatus: any) => ({
					...prevStatus,
					[key]: true,
				}));
			}
		});
		resetControlDisplayTabs(data);
	};

	const fetchControlsDetails = async (
		isEditAcessEnabledByDefault?: boolean,
	) => {
		setIsEntityDetailsLoading(true);
		const response = await getControlData(entityId);

		if (response?.statusCode === OK) {
			const { responseBody } = response;

			if (responseBody) {
				setInitialDetails(responseBody);
				setSelectedEntityName(responseBody?.name ?? '');
				dispatch(
					setCitationDataHandler({
						entityName: responseBody?.name ?? '',
						entityId,
						industryType: responseBody?.industryType ?? '',
					}),
				);
				setObjective(
					fetchKeyBasedOnRole(
						hasInvManagerAccess,
						CONTROL_OBJECTIVE_KEYWORD,
						responseBody,
					),
				);
				setControlStatement(
					fetchKeyBasedOnRole(
						hasInvManagerAccess,
						CONTROL_STATEMENT_KEYWORD,
						responseBody,
					),
				);

				setControlTestScripts(
					fetchKeyBasedOnRole(
						hasInvManagerAccess,
						CONTROL_TEST_SCRIPTS_KEYWORD,
						responseBody,
					),
				);

				resetStatementSectionActions(
					responseBody,
					isEditAcessEnabledByDefault ?? false,
				);

				setEntityDetails(fetchFormattedDetailsForEntity(responseBody));
				getControlTabsValidation(
					responseBody?.controlObjective || '',
					responseBody?.controlStatement || '',
				);
				setSelectedEntityData(responseBody);
			}
			setIsEntityDetailsLoading(false);
		} else {
			setIsEntityDetailsLoading(false);
		}
	};
	const fetchRisksDetails = async (isEditAcessEnabledByDefault?: boolean) => {
		setIsEntityDetailsLoading(true);
		const response = await getRiskData(entityId);

		if (response?.statusCode === OK) {
			const { responseBody } = response;
			if (responseBody) {
				setInitialDetails(responseBody);
				dispatch(
					setCitationDataHandler({
						entityName: responseBody?.riskName ?? '',
						entityId,
						industryType: responseBody?.industryType ?? '',
					}),
				);
				const statement: string = fetchKeyBasedOnRole(
					hasInvManagerAccess,
					RISK_STATEMENT_KEYWORD,
					responseBody,
				);
				setSelectedEntityName(responseBody?.riskName ?? '');
				setObjective(statement || '');
				setShowStatement(statement !== '');
				setEntityDetails(fetchFormattedDetailsForEntity(responseBody));
				if (
					disableBtnBasedOnRoleAndNewValue(
						hasInvManagerAccess,
						RISK_STATEMENT_KEYWORD,
						responseBody,
						isEditAcessEnabledByDefault,
					)
				) {
					setDisableBtnStatus((prevStatus: any) => ({
						...prevStatus,
						[CONTROL_OBJECTIVE_LOADER]: true,
					}));
				}
				setIsEntityDetailsLoading(false);
			}
		} else if (
			response?.statusCode !== FORBIDDEN &&
			response?.statusCode !== OK
		) {
			setIsEntityDetailsLoading(false);
			dispatch(
				setToastMessage({
					message: response?.errorBody?.errorMessage || APP_GENERAL_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};
	const fetchProcessesDetails = async () => {
		setIsEntityDetailsLoading(true);
		const response = await getProcessData(entityId);

		if (response.statusCode === OK) {
			const { responseBody } = response;
			if (responseBody) {
				setInitialDetails(responseBody);
				dispatch(
					setCitationDataHandler({
						entityName: responseBody?.processName ?? '',
						entityId,
						industryType: responseBody?.industryType ?? '',
					}),
				);
				setEntityDetails(fetchFormattedDetailsForEntity(responseBody));
				setIsEntityDetailsLoading(false);
				setSelectedEntityName(responseBody?.processName ?? '');
			}
		} else {
			setIsEntityDetailsLoading(false);
		}
	};

	const fetchEntityDetails = (isEditAcessEnabledByDefault?: boolean) => {
		switch (selectedEntityType) {
			case CONTROL:
				fetchControlsDetails(isEditAcessEnabledByDefault);
				break;
			case RISK:
				fetchRisksDetails(isEditAcessEnabledByDefault);
				break;
			case PROCESS:
				fetchProcessesDetails();
				break;
			default:
				fetchControlsDetails(isEditAcessEnabledByDefault);
		}
	};
	const goBackHandler = () => {
		deletePendingAICards(
			entityId,
			fetchPayloadForRegenerateChanges(
				entityId,
				selectedEntityType,
				selectedEntityName,
				riskRefTaxonomySourceFiltersKey,
				initialDetails?.industryType,
			),
			dispatch,
		);
		dispatch(setCitationDataHandler({}));
		dispatch(setIsRegenerateMappingBtnClicked(false));
		navigate(-1);
	};

	/**
	 * @description method to fetch list of meta data from api
	 * @param metaData
	 */
	const fetchListOfMetaData = async (
		metaDataLabel: string,
		label: string,
		value: string | string[],
	) => {
		setIsMultiEditMetaDataModalOpen(true);
		setIsMetaDataListLoading(true);
		setMetaDataLabel(label);
		const response = await getListOfMetaData(
			riskRefTaxonomySourceFiltersKey,
			metaDataLabel,
		);
		setIsMetaDataListLoading(false);
		if (response?.statusCode === OK) {
			setListOfMetaData(response?.responseBody[metaDataLabel]);
			const updatedSelectedOption = filterMetaData(
				value,
				response?.responseBody[metaDataLabel],
			);
			setMultiSelectedMetaDataOption(updatedSelectedOption); // to populate the data of selectedOptions
		} else {
			fetchToastMsgData(response, OK, dispatch, null);
		}
	};

	/**
	 * @description method to close the add mapping modal
	 */
	const modalCloseHandler = (isAdded: boolean) => {
		setIsModalOpen(false);
		if (isAdded) {
			setUpdatedPayloadData({ ...updatedPayloadData, aiGenerated: true });
		}
	};

	/**
	 * @description method to trigger add mapping button is clicked
	 */
	const addMappingClickHandler = () => {
		setIsModalOpen(true);
	};

	/**
	 * @description method to trigger when edit is clicked for listed meta data
	 */
	const onEditMetaDataMultiClickHandler = async (
		label: string,
		value: string | string[],
		key: any,
	) => {
		const metaDataLabel = fetchKeywordBasedOnLabel(label);
		setMetaDatakey(
			key?.toLowerCase() === BUSINESS_UNIT_KEYWORD?.toLowerCase()
				? INDUSTRY_KEYWORD
				: key,
		);
		fetchListOfMetaData(metaDataLabel, label, value);
	};

	/**
	 * @description method to close the edit meta data modal
	 */
	const metaDataMultiEditModalCloseHandler = () => {
		setMultiSelectedMetaDataOption([]);
		setDisableUpdateBtn(true);
		setIsMultiEditMetaDataModalOpen(false);
	};

	/**
	 * @description method to handle meta data change
	 * @param event
	 */
	const handleEditMetaDataMultiChange = (
		event: SelectChangeEvent<typeof mutilSelectedMetaDataOption>,
		isMultiSelect: boolean,
	) => {
		const {
			target: { value },
		} = event;
		selectMetaDataFromDropdown(
			isMultiSelect,
			listOfMetaData,
			value,
			initialDetails,
			metaDataKey,
			setDisableUpdateBtn,
			setMultiSelectedMetaDataOption,
		);
	};

	/**
	 * @description method to trigger when update of the meta data is clicked
	 * @param  selectedMetaDataOption
	 */
	const updateMultiMetaDataHandler = (
		selectedMetaDataOption: IListOfMetaData[],
	) => {
		const entityValues = selectedMetaDataOption?.map(
			(item) => item?.displayValue,
		);

		if (isIndustryTypeOrBusinessUnit(metaDataKey)) {
			setIndustryType(entityValues?.join(','));
			setBusinessUnit(entityValues?.join(','));
		}
		setUpdatedPayloadData((prevFormData: any) => ({
			...prevFormData,
			[metaDataKey]: {
				id: null,
				old: initialDetails[metaDataKey],
				newValue: isIndustryTypeOrBusinessUnit(metaDataKey)
					? entityValues?.join(',')
					: entityValues[0],
			},
		}));
		updateControlHeader(
			selectedEntityType,
			metaDataKey,
			entityValues,
			setControlHeader,
		);
		setIsMultiEditMetaDataModalOpen(false);
	};

	/**
	 * @description method to trigger when regenerate btn is clicked for relation mapping
	 */
	const onRegenerateBtnClickHandler = async () => {
		dispatch(setIsRegenerateMappingBtnClicked(true));
		setIsRegenerating(true);
		const response = await regenerateCards(
			fetchPayloadForRegenerateChanges(
				entityId,
				selectedEntityType,
				selectedEntityName,
				riskRefTaxonomySourceFiltersKey,
				Array?.isArray(initialDetails?.industryType)
					? initialDetails?.industryType?.join(',')
					: initialDetails?.industryType,
			),
		);
		setIsRegenerating(false);
		if (response?.statusCode === OK) {
			setRelationMappingTabValue(AI_GENERATED);
			setUpdatedPayloadData({ ...updatedPayloadData, aiGenerated: true });
		}
		fetchToastMsg(
			response,
			OK,
			PRC_REGENERATE_SUCCESS,
			PRC_REGENERATE_FAILURE,
			dispatch,
		);
	};

	/**
	 * @description method to trigger when submit changes btn is clicked
	 */
	const submitChangesHandler = async () => {
		setIsSubmitDetailsLoading(true);
		const updatedPayloadDataObj: any = updatePayloadToCheckWithAuditKey(
			updatedPayloadData,
			auditKey,
			auditID,
		);

		const finalPayload = {
			...updatedPayloadDataObj,
			entityId,
			entityType: selectedEntityType,
			entityName: selectedEntityName,
			requestedBy: `${loggedInUser?.firstName} ${loggedInUser?.lastName}`,
		};
		const response = await submitPRCEditChanges(finalPayload);
		setIsSubmitDetailsLoading(false);
		setIsSubmitModalOpen(false);
		fetchToastMsgData(
			response,
			OK,
			dispatch,
			PRC_CHANGES_SUCCESS,
			PRC_CHANGES_FAILURE,
		);
		if (response?.statusCode === OK) {
			setRelationMappingTabValue(ALL);
			fetchEntityDetails(getEditAccessEnabledFlag());
			dispatch(setIsRegenerateMappingBtnClicked(false));
			setIsDiscardBtnClicked(false);
			setUpdatedPayloadData({});
			fetchToastMsgData(response, OK, dispatch, PRC_CHANGES_SUCCESS);
		}
	};

	/**
	 * @description method to reset data when discard btn is clicked
	 */
	const discardBtnClickHandler = async () => {
		setIsDiscardBtnClicked(true);
		const res = await deletePendingAICards(
			entityId,
			fetchPayloadForRegenerateChanges(
				entityId,
				selectedEntityType,
				selectedEntityName,
				riskRefTaxonomySourceFiltersKey,
				initialDetails?.industryType,
			),
			dispatch,
		);
		fetchToastMsg(
			res,
			OK,
			PRC_REGENERATE_DELETE_SUCCESS,
			PRC_REGENERATE_DELETE_FAILURE,
			dispatch,
		);
		if (res?.statusCode === OK) {
			setUpdatedPayloadData({});
			dispatch(setIsRegenerateMappingBtnClicked(false));
			setIsDiscardBtnClicked(false);
			setRelationMappingTabValue(ALL);
			fetchEntityDetails(getEditAccessEnabledFlag());
			setIsChangesDiscarded(true);
		}
	};

	const onStatementTextChange = (value: any, key: string) => {
		if (selectedEntityType === RISK) {
			key = RISK_STATEMENT_KEY;
		} else if (tabValue === CONTROL_OBJECTIVE) {
			key = CONTROL_OBJECTIVE_KEYWORD;
		}
		setUpdatedPayloadData((prevFormData: any) => ({
			...prevFormData,
			[key]: {
				id: null,
				old: initialDetails[key],
				newValue: value,
			},
		}));
	};

	const getControlTabsValidation = (
		objectiveText: string,
		statementText: string,
	) => {
		if (!objectiveText?.length && !statementText?.length) {
			return false;
		}

		const tabs =
			objectiveText?.length === 0
				? []
				: [{ label: CONTROL_OBJECTIVE, value: CONTROL_OBJECTIVE }];

		if (statementText?.length) {
			tabs.push(
				{ label: CONTROL_STATEMENT, value: CONTROL_STATEMENT },
				{ label: CONTROL_TEST_SCRIPTS, value: CONTROL_TEST_SCRIPTS },
			);
		}

		setControlTabs(tabs);
		return true;
	};

	useEffect(() => {
		dispatch(
			setDeleteAIGeneratedCardPayload(
				fetchPayloadForRegenerateChanges(
					entityId,
					selectedEntityType,
					selectedEntityName,
					riskRefTaxonomySourceFiltersKey,
					initialDetails?.industryType,
				),
			),
		);
	}, []);

	useEffect(() => {
		const { pathname } = location;
		const pathSegments = pathname.split('/').filter(Boolean);
		if (pathSegments?.length > 4) {
			const type = pathSegments[3];
			const auditId = pathSegments[4];
			const auditKey = pathSegments[5];
			const id = pathSegments[2];
			setAuditKey(auditKey);
			setAuditID(auditId);
			setSelectedEntityType(type);
			setRoutePath(HOME_PAGE);
			setEditAccessEnabled(true);
			setEntityId(id);
		} else {
			const id = pathSegments[2];
			const entitytype = pathSegments[3];
			setRoutePath(PRC_INVENTORY_PAGE);
			setSelectedEntityType(entitytype);
			setEntityId(id);
		}
	}, [location]);
	useEffect(() => {
		if (entityId) {
			if (routePath === PRC_INVENTORY_PAGE) {
				fetchEntityDetails(getEditAccessEnabledFlag());
			} else {
				fetchEntityDetails(true);
			}
		}
	}, [entityId]);

	const handleAddCoveredProduct = () => {
		fetchEntityDetails(getEditAccessEnabledFlag());
	};
	const handleDeleteCoveredProduct = () => {
		if (coveredProductNames.length > 1) {
			fetchEntityDetails(getEditAccessEnabledFlag());
		} else {
			setCoveredProductNames([]);
		}
	};

	const handleClose = useCallback(() => {
		// close the toast message
		setToastMessage({
			message: '',
			severity: '',
			isToastOpen: false,
		});
		dispatch(
			setToastMessage({
				message: '',
				severity: '',
				isToastOpen: false,
			}),
		);
	}, []);
	const breadcrumbs = displayIdUpdated
		? [
				<Link
					key="1"
					state={{ entityType: '', entityName: '' }}
					to={navigateToPage(routePath)}
					onClick={goBackHandler}
					data-testid="firstLevel-test"
				>
					{routePath}
				</Link>,
				<Typography key="1">{displayIdUpdated}</Typography>,
		  ]
		: [
				<Link
					key="1"
					state={{ entityType: '', entityName: '' }}
					to={navigateToPage(routePath)}
					onClick={goBackHandler}
					data-testid="firstLevel-test"
				>
					{routePath}
				</Link>,
		  ];

	const headerSectionComp = (
		label: string,
		value: string | string[],
		key: string,
	) => (
		<div>
			{value && (
				<Typography className={entityStyles['industrytype-text']}>
					{toSentenceCase(label)}
					{fetchValueBasedOnIncomingType(value)}
					{hasInvManagerAccess && (
						<Icon>
							<EditIcon
								data-testid="edit-icon"
								onClick={() => {
									onEditMetaDataMultiClickHandler(label, value, key);
								}}
								fill={iconFillColor}
								className={`${entityStyles['edit-icon']} ${
									isSubmitDetailsLoading ||
									isRegenerating ||
									(isPRCEditDataDeleting && isDiscardBtnClicked) ||
									disableBtnBasedOnRoleAndNewValue(
										hasInvManagerAccess,
										key,
										initialDetails,
										isEditAccessEnabled,
									)
										? entityStyles['disable-btn']
										: ''
								}`}
							/>
						</Icon>
					)}
				</Typography>
			)}
		</div>
	);

	const renderHeaderSectionTitles = (parentEntityType: string) => {
		let component;
		if (
			parentEntityType?.toLowerCase() === PROCESS?.toLowerCase() ||
			parentEntityType?.toLowerCase() === RISK?.toLowerCase()
		) {
			component = (
				<div>
					{riskRefTaxonomySourceFiltersKey?.toLowerCase() ===
					PWC_CURATED_LIBRARY?.toLowerCase()
						? headerSectionComp(
								`${INDUSTRY_LABEL} : `,
								convertStringToArray(industry),
								INDUSTRY_KEYWORD,
						  )
						: headerSectionComp(
								`${BUSINESS_UNIT_LABEL} : `,
								convertStringToArray(businessUnit),
								BUSINESS_UNIT_KEYWORD,
						  )}
				</div>
			);
		} else if (parentEntityType?.toLowerCase() === CONTROL?.toLowerCase()) {
			component = (
				<div className={entityStyles['control-header-text']}>
					{controlHeader?.map(
						(headerData) =>
							headerData?.labelValue?.length > 0 &&
							headerSectionComp(
								`${
									headerData?.headerLabel
										? `${toSentenceCase(headerData?.headerLabel)} : `
										: ''
								}`,
								headerData?.labelValue,
								headerData?.headerKey,
							),
					)}
				</div>
			);
		}
		return component;
	};

	const getTabDisplayStatus = () => {
		if (controlObjective?.length > 0 || controlStatement?.length > 0) {
			return true;
		}

		return false;
	};

	const handlePreviewDrawerClose = (isDeleted: boolean) => {
		if (isDeleted) {
			setUpdatedPayloadData({ ...updatedPayloadData, aiGenerated: true });
		}
	};
	/** Clean up the pending ai cards */
	useEffect(
		() => () => {
			const { pathname } = location;
			const pathSegments = pathname.split('/').filter(Boolean);
			if (entityData) {
				deletePendingAICards(
					entityData.entityId,
					fetchPayloadForRegenerateChanges(
						entityData.entityId,
						pathSegments[3],
						entityData.entityName,
						riskRefTaxonomySourceFiltersKey,
						entityData?.industryType,
					),
					dispatch,
				);
			}
		},
		[entityData],
	);
	return (
		<Grid className={styles['page-background']}>
			<>
				<Box className={`${entityStyles['text-box']}`} data-testid="menu-box">
					<Breadcrumbs
						breadcrumbs={breadcrumbs}
						customClass
						className={entityStyles['entity-bread-crumbs']}
					/>
					<Box className={entityStyles['entity-text-container']}>
						{isEntityDetailsLoading ? (
							<Loader show />
						) : (
							<>
								<Typography className={entityStyles['main-text']} pb={2}>
									{selectedEntityName}
								</Typography>
								{renderHeaderSectionTitles(selectedEntityType)}
							</>
						)}
					</Box>
					{isMultiEditMetaDataModalOpen && (
						<MetaDataEditModal
							metaDataKey={metaDataKey}
							isMultiSelect={isIndustryTypeOrBusinessUnit(metaDataKey)}
							isModalOpen={isMultiEditMetaDataModalOpen}
							modalCloseHandler={metaDataMultiEditModalCloseHandler}
							editMetaData={fetchLabelBasedOnMetaData(metaDataLabel)}
							metaDataArray={listOfMetaData}
							selectedMetaDataOption={mutilSelectedMetaDataOption}
							handleEditMetaDataChange={handleEditMetaDataMultiChange}
							updateMetaDataHandler={updateMultiMetaDataHandler}
							isMetaDataListLoading={isMetaDataListLoading}
							disableUpdateBtn={
								disableUpdateBtn || !mutilSelectedMetaDataOption?.length
							}
						/>
					)}
					{isSubmitModalOpen && (
						<SubmitChangesModal
							modalType={SUBMIT}
							isModalOpen={isSubmitModalOpen}
							isSubmitting={isSubmitDetailsLoading}
							modalCloseHandler={() => setIsSubmitModalOpen(false)}
							submitDataHandler={submitChangesHandler}
						/>
					)}
					<>
						{isEntityDetailsLoading ? (
							<Grid item xs={12}>
								<Loader show />
							</Grid>
						) : (
							<>
								{!isEntityDetailsLoading &&
									selectedEntityType?.toLowerCase() === CONTROL.toLowerCase() &&
									getTabDisplayStatus() && (
										<TabContext value={tabValue}>
											<TabList
												sx={style}
												onChange={(
													event: React.SyntheticEvent,
													value: string,
												) => tabValueChangeHandler(event, value)}
												className={entityStyles['panel-layout']}
											>
												{controlTabs?.map((tabData: ITabValueData) => (
													<StyledTab
														key={tabData?.value}
														data-testid="tabs-value"
														label={tabData?.label}
														value={tabData?.value}
													/>
												))}
											</TabList>
										</TabContext>
									)}
								{showStatement && (
									<EntityStatementSection
										entityType={selectedEntityType}
										objective={controlObjective}
										tabValue={tabValue}
										onTextSave={onStatementTextChange}
										controlStatement={controlStatement}
										controlTestScripts={controlTestScripts}
										type={selectedEntityData?.type}
										frequency={selectedEntityData?.frequency}
										disableBtnStatus={disableBtnStatus}
										isFieldEditable={hasInvManagerAccess}
									/>
								)}
							</>
						)}{' '}
					</>
				</Box>
				<div
					className={`${styles['main-tabs-box']} ${entityStyles['align-content']} `}
				>
					<Box
						sx={{
							borderBottom: 0,
							marginTop: selectedEntityType !== PROCESS ? '5px' : '0px',
						}}
					>
						<Grid container>
							<Grid
								container
								spacing={3}
								className={entityStyles['covered-products-container']}
							>
								{renderOnlyForPRC(selectedEntityType) &&
									!isEntityDetailsLoading &&
									levelList?.length > 0 && (
										<Grid item xs={12} data-testid="levels-section">
											<HierarchyCard coveredLists={levelList} />
										</Grid>
									)}

								<Grid
									item
									xs={12}
									data-testid="covered-products-section"
									className={entityStyles['covered-products-section-container']}
									sx={{
										marginTop: selectedEntityType !== PROCESS ? '20px' : '0px',
									}}
								>
									{renderCoveredPdts(industry) && (
										<CoveredComp
											addNew
											onAdd={handleAddCoveredProduct}
											onDelete={handleDeleteCoveredProduct}
											heading="Covered Products"
											coveredLists={coveredProductNames}
											tooltip={COVERED_PRODUCTS}
											enableSearch
											id={detailsId}
											productDetails={products}
											onHoverDelete
											entityType={selectedEntityType}
											entityId={entityId}
										/>
									)}
								</Grid>
							</Grid>
						</Grid>
						<Grid
							className={entityStyles['entity-container']}
							data-testid="relationship-mapping-section"
						>
							{selectedEntityType && (
								<RelationMappingLayout
									modalCloseHandler={modalCloseHandler}
									addMappingClickHandler={addMappingClickHandler}
									isModalOpen={isModalOpen}
									onRegenerateBtnClickHandler={onRegenerateBtnClickHandler}
									setTabValue={setRelationMappingTabValue}
									tabValue={relationMappingTabValue}
									isSubmitDetailsLoading={isSubmitDetailsLoading}
									isRegenerating={isRegenerating || isDiscardBtnClicked}
									isDeleting={isPRCEditDataDeleting && isDiscardBtnClicked}
									isSubmitModalOpen={isSubmitModalOpen}
									isRegenerateMappingBtnClicked={isRegenerateMappingBtnClicked}
									entityType={selectedEntityType}
									entityId={entityId}
									isChangesDiscarded={isChangesDiscarded}
								/>
							)}
						</Grid>
					</Box>
				</div>
			</>

			<SideDrawer
				className={entityStyles['side-drawer']}
				drawerState={sideDrawerState}
				customClass={entityStyles['custom-width']}
				isBorderRadius
			>
				<PreviewMappingLayout drawerCloseHandler={handlePreviewDrawerClose} />
			</SideDrawer>
			<AlertComponent
				open={isToastOpen ?? false}
				toastMessage={message ?? ''}
				severity={severity ?? ''}
				handleCloseMessage={handleClose}
				vertical="top"
				horizontal="right"
			/>
			{hasInvManagerAccess &&
				Object?.keys(updatedPayloadData)?.length > 0 &&
				!isSubmitChangesButtonDisabled && (
					<Grid className={entityStyles['btn-footer-container']}>
						<Stack className={entityStyles['btn-wrapper']}>
							<ButtonComp
								btnType="secondary"
								clickHandler={discardBtnClickHandler}
								data-testid="discard-button"
								loading={isPRCEditDataDeleting && isDiscardBtnClicked}
								disabled={
									isSubmitDetailsLoading ||
									isRegenerating ||
									!Object?.keys(updatedPayloadData)?.length
								}
							>
								{DISCARD_CHANGES}
							</ButtonComp>
							<ButtonComp
								btnType="primary"
								clickHandler={() => {
									setIsSubmitModalOpen(true);
								}}
								disabled={disableSubmitChangesBtn(
									updatedPayloadData,
									isRegenerateMappingBtnClicked,
									isRegenerating,
									isPRCEditDataDeleting,
									isDiscardBtnClicked,
								)}
								loading={isSubmitDetailsLoading}
								data-testid="submit-button"
							>
								{SUBMIT_CHANGES}
							</ButtonComp>
						</Stack>
					</Grid>
				)}
		</Grid>
	);
};
export default EntityLandingPageLayout;
